const projectDataList = [{
    "title": "RunInsight",
    "project": "RunInsight",
    "hidden": true, // 暂时隐藏，改为 false 即可重新显示
    "category": "iOS App · SwiftUI · HealthKit · AI Coach",
    "summary": "A privacy-first iOS running journal that turns HealthKit workouts into routes, performance charts, shoe mileage, and AI coaching notes.",
    descriptionList: [
        "1. **Built** a SwiftUI running companion that imports workouts from **HealthKit** into a local **SwiftData** journal.",
        "2. **Designed** the core experience: route history, pace and heart-rate breakdowns, **7+ performance metrics**, and automatic per-shoe mileage tracking.",
        "3. **Integrated** **OpenAI Responses API** and **Alibaba DashScope** so users can analyze a selected run and ask follow-up questions.",
        "4. **Protected privacy by design**: the AI coach receives only summary stats, while GPS samples stay on-device and API keys live in **iOS Keychain**.",
        "5. **Localized** the product in **Simplified Chinese and English**."
    ],
    "downloadFiles": [],
    "GitHubLink": "https://github.com/Reece-Lu/RunInsight",
    "pageLink": "/runinsight",
    "icons": ["SwiftUI", "SwiftData", "HealthKit", "MapKit", "OpenAI"],
    "partners": ["Yuwen Lu"],
    "time": "Apr 2026 - May 2026",
    "exploreButton": {
        "label": "Open RunInsight",
        "link": "/runinsight"
    }
},
    {
    "title": "Laptop Price Prediction",
    "project": "Laptop Price Prediction",
    "category": "Course Project for CSC503",
    "summary": "A project aimed at predicting the prices of laptops using web crawling and machine learning techniques.",
    descriptionList: [
        "1. **Developed** a Scrapy-based crawler to **extract data** from Smartprix.com, **gathered** a **21.9MB dataset** including **2230 laptops**.",
        "2. **Performed data cleaning** and **preprocessing** on raw HTML data, **transformed** into a **structured dataset** with **53 features** and **price label**.",
        "3. **Implemented pipeline** for **preprocessing**, **applied decision tree** and **linear regression models** for **price prediction**."
    ],
    "downloadFiles": [
        {
            "fileName": "Raw Data",
            "fileExtension": ".csv",
            "iconName": "csv",
            "filenameOnServer": "CSC503 Laptop Price Prediction with Web Crawling Raw Data.csv"
        },
        {
            "fileName": "Processed Data",
            "fileExtension": ".csv",
            "iconName": "csv",
            "filenameOnServer":"CSC503 Laptop Price Prediction with Web Crawling Cleaned Data.csv"
        },
        {
            "fileName": "Project Report",
            "fileExtension": ".pdf",
            "iconName": "pdf",
            "filenameOnServer":"CSC503 Laptop Price Prediction with Web Crawling.pdf"
        },
        {
            "fileName": "Project Slides",
            "fileExtension": ".pdf",
            "iconName": "pdf",
            "filenameOnServer":"CSC503 Laptop Price Prediction with Web Crawling Presentation Slides.pdf"
        }
    ],
    "GitHubLink": "https://github.com/Reece-Lu/Laptop_Data_Crawler_and_Price_Prediction_UvicCSC503Project",
    "pageLink": "",
    "icons": ["Python", "Scrapy", "scikit-learn","Pandas", "NumPy"],
    "partners": [
        "Chengze Hao, Yuwen Lu"
    ],
    "time": "Jun 2023 - Jul 2023",
    "exploreButton": {
        "label": "Explore",
        "link": "https://link-to-explore.com"
    }
},
    {
        "title": "TradingView News Collector",
        "project": "TradingView News Collector",
        "category": "Personal Project · Market News Data Pipeline",
        "summary": "Collects and archives Nasdaq-100 news from TradingView under a strict daily API quota, and serves it as a searchable news feed.",
        descriptionList: [
            "1. **Built** a Python collector that pulls **headlines and full text** for the **Nasdaq-100 members and QQQ** from TradingView's **MCP service** twice a day, archiving **18,000+ stories** in **MySQL**.",
            "2. **Designed** around a strict **daily API quota**: each round spends an **even share of the remaining budget**, polls the stalest symbols first and fetches **full text for the newest stories first**.",
            "3. **Served** the archive through a read-only **FastAPI** endpoint and a **React** news table with symbol, keyword, source and date filters, deployed with **Docker** behind **Nginx** with per-visitor **rate limiting**."
        ],
        "downloadFiles": [],
        "GitHubLink": "",
        "pageLink": "/newsmonitor",
        "pageInNewTab": false, // a page of this site: open in the same tab
        "icons": ["Python", "FastAPI", "MySQL", "Docker", "Ubuntu"],
        "partners": [
            "Yuwen Lu"
        ],
        "time": "Oct 2026 - Present",
        "exploreButton": {
            "label": "Open News Feed",
            "link": "/newsmonitor"
        }
    },
    {
        "title": "Quantum Machine Learning",
        "project": "Quantum Machine Learning",
        "hidden": true, // 已被 TradingView News Collector 替换，改为 false 即可重新显示
        "category": "Course Project for CSC586A",
        "summary": "Exploring quantum machine learning techniques with a focus on quantum convolutional neural networks.",
        descriptionList: [
            "1. **Conducted research** on Quantum Machine Learning, exploring its history and applications. Presented findings to professors and students.",
            "2. **Implemented** quantum convolutional neural networks using **PyTorch** and **Qiskit**, achieving **80% accuracy** on a dataset of colored images.",
            "3. **Demonstrated** the potential of Quantum Machine Learning for improved speed and performance in handling complex tasks." ],
        "downloadFiles": [
            {
                "fileName": "Research Paper",
                "fileExtension": ".pdf",
                "iconName": "pdf",
                "filenameOnServer":"Quantum Machine Learning (Convolutional neural network as an example)_V01022209_Yuwen_Lu.pdf"
            },
            {
                "fileName": "Presentation Slides",
                "fileExtension": ".pdf",
                "iconName": "pdf",
                "filenameOnServer":"Quantum Machine Learning (Convolutional neural network as an example)_V01022209_Yuwen_Lu Presentation Slides.pdf"
            },
            {
                "fileName": "Jupyter Notebook",
                "fileExtension": ".ipynb",
                "iconName": "ipynb",
                "filenameOnServer":"Quantum Machine Learning (Convolutional neural network as an example)_V01022209_Yuwen_Lu.ipynb"
            }
        ],
        "GitHubLink": "https://github.com/Reece-Lu/QML-Model-Serving",
        "pageLink": "",
        "icons": ["Python", "PyTorch", "Qiskit", "Jupyter","FastAPI"],
        "partners": [
            "Yuwen Lu"
        ],
        "time": "Jan 2023 - Apr 2023",
        "exploreButton": {
            "label": "Explore",
            "link": "https://quantum-machine-learning-explore-link.com"
        }
    },
    {
        "title": "Residential Complex Management Website",
        "project": "Residential Complex Management Website",
        "category": "Undergraduate Graduation Design Project",
        "summary": "Developed a comprehensive property management system following software engineering standards.",
        descriptionList: [
            "1. **Developed** the entire property management system independently, following B/S architecture ensuring front-end/back-end separation.",
            "2. **Conducted** feasibility and requirements analysis, and designed a relational database with **MySQL** consisting of 12 tables.",
            "3. **Designed** and **developed** the back-end with **Spring Boot**, providing 29 APIs for the front-end.",
            "4. **Designed** and **developed** the front-end with **Vue.js**, adapting for both mobile and computer browsers.",
            "5. **Integrated** SMS service to enhance security and conducted system testing, including stress testing using **AliCloud's PTS**.",
            "6. **Deployed** the project on **Alibaba Cloud ECS**, applied for a domain name, and prepared comprehensive project reports."
        ],
        "downloadFiles": [
            {
                "fileName": "Project Report(Chinese)",
                "fileExtension": ".pdf",
                "iconName": "pdf",
                "filenameOnServer":"Residential_Complex_Management_Report_Chinese.pdf"
            },{
                "fileName": "Project Report(Machine Translation)",
                "fileExtension": ".pdf",
                "iconName": "pdf",
                "filenameOnServer":"Residential_Complex_Management_Report_English_DeepL_Translate_Machine.pdf"
            }
        ],
        "GitHubLink": [
            "https://github.com/Reece-Lu/propertymanagement-graduationproject-server"
        ],
        "pageLink": "/residentialcomplex/",
        "icons": ["Spring", "Vue", "MySQL", "Docker","Ubuntu"],
        "partners": [
            "Yuwen Lu"
        ],
        "time": "Jan 2022 - Jun 2022",
        "exploreButton": {
            "label": "Explore",
            "link": "https://property-management-explore-link.com"
        }
    }];

export default projectDataList;
